import "./CheckoutSuccess.css"
import success_img from "../../images/checkout_success_bear.png"

import { 
    useNavigate,
} from "react-router-dom";
import React from "react";


export const CheckoutSuccessHeader = () => {
    return (
      <div className="checkout-success-page-header-div">
          Order Placed Successfully!!!
      </div>
    );
  };

export const SuccessImg = () => {
    return (
        <div className="checkout-success-page-image-container">
            <img 
                className="checkout-success-page-image" 
                src={success_img} 
                alt={"Image of a toy bear holding a 'Success!' sign"} 
            />
            <div className="checkout-success-page-image-lower-text">
                Your order will be delivered soon. Thank you for choosing us!
            </div>
        </div>
    )
}

interface ButtonProp {
    participant_code: string;
}

export const ContinueButton: React.FC<ButtonProp> = ({participant_code}) => {

    const navigate = useNavigate();

    const handleContinueShopping = () => {
        const url = participant_code
            ? `/participant-shop/part-id/${participant_code}`
            : "/register-or-shop";

        navigate(url); // Navigate to the constructed URL
    };

    return (
        <div className="checkout-success-page-image-container">
            <button 
                onClick={handleContinueShopping}
                className="checkout-success-page-continue-btn">
                    Continue Shopping
            </button>
        </div>
    )
}
  